import {createAction} from '../../base/fsa';

export const addUARTMessageAction = createAction(
    resolve => (message: string, type: string, time: string) => resolve({message, type, time}),
);

export const clearUARTMessagesAction = createAction();
